import axios from '@/libs/api.request'

// 短剧审核管理接口 API

/** 分页查询 TT 短剧审核列表 */
export const getTtMediaReviewPage = (params) => {
    return axios.request({
        method: 'get',
        params,
        url: '/tiktok/minis/review/page'
    })
}

/** 获取 TT 短剧送审资料（查看资料弹窗） */
export const getTtMediaReviewMaterials = (id, params) => {
    return axios.request({
        method: 'get',
        params,
        url: `/tiktok/minis/review/${id}/materials`
    })
}

/** 查询 TT 短剧 BP 同步失败明细 */
export const getTtMediaReviewSyncFailures = (id) => {
    return axios.request({
        method: 'get',
        url: `/tiktok/minis/review/${id}/sync-failures`
    })
}

/** 查询 TT 短剧审核版本记录（审核记录弹窗） */
export const getTtMediaReviewVersions = (id) => {
    return axios.request({
        method: 'get',
        url: `/tiktok/minis/review/${id}/versions`
    })
}

/** 预览 TT 短剧原片与字幕（在线预览弹窗） */
export const getTtMediaReviewPreview = (id, params) => {
    return axios.request({
        method: 'get',
        params,
        url: `/tiktok/minis/review/${id}/preview`
    })
}

/** 修改素材并重新送审 TT 短剧 */
export const postTtMediaReviewResubmit = (id, data) => {
    return axios.request({
        method: 'post',
        data,
        url: `/tiktok/minis/review/${id}/resubmit`,
        skipIntercept: true
    })
}

/** 查询 TT 短剧申诉详情（查看申诉理由弹窗） */
export const getTtMediaReviewAppeal = (id, params) => {
    return axios.request({
        method: 'get',
        params,
        url: `/tiktok/minis/review/${id}/appeal`
    })
}

/** 提交 TT 短剧审核申诉 */
export const postTtMediaReviewAppeal = (id, data) => {
    return axios.request({
        method: 'post',
        data,
        url: `/tiktok/minis/review/${id}/appeal`,
        skipIntercept: true
    })
}

/** 撤回 TT 短剧审核（最近送审且审核中） */
export const postTtMediaReviewWithdraw = (id, data) => {
    return axios.request({
        method: 'post',
        data,
        url: `/tiktok/minis/review/${id}/withdraw`
    })
}
